<div class="absolute inset-0 -z-10 bg-gray-200"></div>

<layout-page-container class="">
  <layout-header-container [title]="title">
    <div class="ml-auto place-self-center">
      <span class="isolate inline-flex rounded-md shadow-sm">
        <button (click)="onCancel.emit()"
                class="relative inline-flex items-center rounded-l-md bg-white px-3 py-2 text-sm text-gray-600 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                type="button">Verwerfen</button>
        <button (click)="onSave.emit()"
                class="relative -ml-px inline-flex items-center rounded-r-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                type="button">
          <a class="text-xl icon-[ph--floppy-disk]"></a>
        </button>
      </span>
    </div>
  </layout-header-container>
  <nav aria-label="Progress" class="pt-2 sm:mt-3">
    <ol class="space-y-4 md:flex md:space-y-0 md:space-x-8" role="list">
      <ng-content select="[steps]"/>
    </ol>
  </nav>
  <!-- No `h-full`: the scroll slot sizes itself from the container's flex column (`flex-1 min-h-0`), so a
       percentage height here is inert and only invites the caller to re-tune the layout from outside (#235). -->
  <layout-page-scrollable class="pt-2">
    @if (!view) {
      <ng-content/>
    } @else {
      <ng-container *ngTemplateOutlet="templates[view]"></ng-container>
    }
  </layout-page-scrollable>
  <div #container class="flex w-full relative">
    @if (id) {
      <div *applyHeight="container"
           class="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-gray-500 text-xs whitespace-nowrap">
        Edit ID:
        <span class="select-all">{{ id }}</span>
      </div>
    }
    @if (view) {
      <div class="py-4 ml-auto">
      <span class="isolate inline-flex rounded-md shadow-sm">
        <button (click)="onPreviousView.emit(view)"
                class="relative inline-flex items-center rounded-l-md bg-white px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                type="button">
          <span class="sr-only">Previous</span>
          <svg aria-hidden="true" class="size-5" data-slot="icon" viewBox="0 0 20 20">
            <path
              clip-rule="evenodd"
              d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
              fill-rule="evenodd"/>
          </svg>
        </button>
        <button (click)="onNextView.emit(view)"
                class="relative -ml-px inline-flex items-center rounded-r-md bg-white px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                type="button">
          <span class="sr-only">Next</span>
          <svg aria-hidden="true" class="size-5" data-slot="icon" viewBox="0 0 20 20">
            <path
              clip-rule="evenodd"
              d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
              fill-rule="evenodd"/>
          </svg>
        </button>
      </span>

      </div>
    }
  </div>
</layout-page-container>
